import React, { useState } from "react";
import  './Expenses.css'

import  Card from '../UI/Card';
import ExpensesFilter from "./Expensefilter";
import ExpensesList from "./ExpensesList";
import Expeneschart from "./ExpensesChart";




function Expenses(props) {

  const [filteredyear,setFilteredYear] = useState('2020')

const filterChangehandler = selectedyear => {
  setFilteredYear(selectedyear)

};

const filteredExpenses = props.items.filter(expense => {
  return expense.date.getFullYear().toString() == filteredyear;

});


  return (
  
    <li>


    <Card className="expenses" >
    <ExpensesFilter selected={filteredyear}  onChangeFilter={filterChangehandler}>

    </ExpensesFilter>

    <Expeneschart  expenses={filteredExpenses}></Expeneschart>

    <ExpensesList items = {filteredExpenses} ></ExpensesList>



    </Card>
    </li>
  );
}

export default Expenses;